import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from '@design-system/theme';
import { forwardRef } from 'react';
import { styled } from 'styled-components';
import { flexbox, layout, space } from 'styled-system';
import { GridHelper } from './GridHelper';
import GridContext from '../contexts/GridContext';
import { useGrid } from '../hooks/useGrid';
export const Grid = forwardRef((_a, inputRef) => {
    var { children, colGap: overrideColGap, columnsInMobile, displayGrid, mt: overrideMt, mx: overrideMx, numCols: overrideNumCols, rowGap: overrideRowGap } = _a, otherProps = __rest(_a, ["children", "colGap", "columnsInMobile", "displayGrid", "mt", "mx", "numCols", "rowGap"]);
    const { displayGridHelper, gridContextValue, ref } = useGrid({
        columnsInMobile,
        displayGrid,
        inputRef,
        overrideColGap,
        overrideNumCols,
        overrideRowGap,
    });
    const theme = useTheme();
    return (_jsx(GridContext.Provider, { value: gridContextValue, children: _jsxs(GridStyled, Object.assign({ mt: overrideMt !== null && overrideMt !== void 0 ? overrideMt : -gridContextValue.rowGap, mx: overrideMx !== null && overrideMx !== void 0 ? overrideMx : theme.grid.gridGap, ref: ref }, otherProps, { children: [displayGridHelper && _jsx(GridHelper, {}), typeof children === 'function'
                    ? children(gridContextValue)
                    : children] })) }));
});
const GridStyled = styled.div.withConfig({
    shouldForwardProp: (prop) => ![
        'alignSelf',
        'height',
        'maxWidth',
        'minHeight',
        'minWidth',
        'mt',
        'mx',
        'my',
        'width',
    ].includes(prop),
}) `
  ${space}
  ${layout}
  ${flexbox}
  position: relative;
`;
//# sourceMappingURL=Grid.js.map